import * as React from "react";
import type { SVGProps } from "react";
const SvgCrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="cross_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M469.333 655.147V896a42.667 42.667 0 1 0 85.334 0V655.147a149.675 149.675 0 0 0 100.48-100.48H896a42.667 42.667 0 1 0 0-85.334H655.147a149.675 149.675 0 0 0-100.48-100.48V128a42.667 42.667 0 1 0-85.334 0v240.853a149.675 149.675 0 0 0-100.48 100.48H128a42.667 42.667 0 1 0 0 85.334h240.853a149.675 149.675 0 0 0 100.48 100.48zM448 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
    />
  </svg>
);
export default SvgCrossIcon;
